import React from "react";
import { X, User2 } from "lucide-react";
import { CircularProgress } from "@mui/material";
import { formatPhoneNumber } from "../utils/formatnumber";

function getDisplayValue(value) {
  if (value == null) return "";
  if (typeof value === "object" && "S" in value) return value.S ?? "";
  return String(value);
}

export default function DeleteContactModal({
  open,
  onClose,
  onDelete,
  contact,
  loader
}) {
  if (!open) return null;

  const displayName =
    getDisplayValue(contact?.name ?? contact?.contact_name) || "Unknown";
  const displayCompany = getDisplayValue(contact?.company);
  const displayPhone = contact?.phoneNumber
    ? (() => {
        try {
          return formatPhoneNumber(
            getDisplayValue(contact.phoneNumber) || contact.phoneNumber
          );
        } catch {
          return getDisplayValue(contact.phoneNumber) || contact.phoneNumber;
        }
      })()
    : "";

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-md rounded-xl shadow-lg p-6 animate-fadeIn">
        
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-800">Delete Contact</h2>

          <button
            onClick={onClose}
            className="p-1 rounded-lg hover:bg-gray-100"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Contact Info */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
            <User2 className="w-6 h-6 text-gray-500" />
          </div>

          <div className="min-w-0 flex-1">
            <p className="text-gray-800 font-medium text-base truncate">
              {displayName}
            </p>
            {displayCompany ? (
              <p className="text-sm text-gray-500 truncate">{displayCompany}</p>
            ) : null}
            {displayPhone ? (
              <p className="text-sm text-gray-500 truncate">{displayPhone}</p>
            ) : null}
          </div>
        </div>

        {/* Warning Message */}
        <p className="text-gray-600 text-sm leading-relaxed mb-6">
          This action cannot be undone. This will permanently delete the contact
          and all associated call history.
        </p>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>

          {loader ? (
            <CircularProgress
                            size={"20px"}
                            sx={{ fontSize: "14px", color: "white" }}
                          />
          ) : (
            <button
            onClick={onDelete}
            className="px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 text-white font-medium"
          >
            Delete Contact
          </button>
          )}
           
        </div>
      </div>
    </div>
  );
}
